export const DutyCalculatorComponent = {
	bindings: {

	},
	templateUrl: 'duty-calculator.html',
	controller: class DutyCalculatorComponent {
		constructor($scope, $timeout) {
			'ngInject';
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.duty = {
				rate: 0.04,
				maxPriceLimit: 30000000,
				middlePriceLimit: 15000000
			};
		}
		$onInit() {
			window.ipEventBus.subscribe('real-estate-duty-change', (channel, {realEstateType, realEstatePrice})=>{
				this.$timeout(()=>{
					this.estateType = realEstateType;
					this.priceValue = realEstatePrice;
					if (this.priceValue && this.estateType) {
						this.countDuty();
					}
					this.visible = true
				});
			}, true);
		}
		// $onChanges(changes) {
		// 	if (changes.realEstatePrice) {
		// 		this.priceValue = angular.copy(this.realEstatePrice);
		// 	}
		// 	if (changes.realEstateType) {
		// 		this.estateType = angular.copy(this.realEstateType);
		// 	}
		// 	if (this.priceValue && this.estateType) {
		// 		this.countDuty();
		// 	}
		// }

		countDuty() {
			let copyOfPrice = this.priceValue;
			if (this.estateType == 'new') {
				if (this.priceValue > this.duty.maxPriceLimit) {
					this.dutyToDisplay = parseFloat(copyOfPrice * this.duty.rate);
				} else {
					if (this.priceValue > this.duty.middlePriceLimit) {
						this.dutyToDisplay = parseFloat((copyOfPrice - this.duty.middlePriceLimit) * this.duty.rate);
					} else {
						this.dutyToDisplay = 0;
					}
				}
			} else {
				this.dutyToDisplay = parseFloat(copyOfPrice * this.duty.rate);
			}
		}
	}
};
